<template>
	
	<div class="twenty-padding scroll-y">
		
		<!-- Manual Entry -->
		
		<legend class="content-area__element-title">Manual Entry</legend>
		
		<div class="card card--shadow card--no-padding" style="margin-bottom: 20px;">
			<TimeBookManualEntry ref="timeBookManualEntry" :preselect-client="$store.getters.client.id" @on-add="onAddTimeBookEntry"></TimeBookManualEntry>
		</div>
		
		<!-- List -->
		
		<TimeBookList ref="timeBookList" v-if="$store.getters.client.id" :preselect-client="$store.getters.client.id" :preselect-daterange="[]"/>
		
	</div>
	
</template>

<script>
	
	import TimeBookManualEntry from "@/components/TimeBook/ManualEntry";
	import TimeBookList from "@/components/TimeBook/List";
	
	export default {
		
		components: { TimeBookManualEntry, TimeBookList },
		
		methods: {
			
			onAddTimeBookEntry(response) {
				this.$refs.timeBookList.refresh();
			},
			
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Clients/TimeBook.vue